
import { ReactNode } from "react";
import ProtectedRoute from "@/components/ProtectedRoute";

export const getDashboardByRole = (role: string) => {
  switch (role) {
    case "admin":
      return "/admin";
    case "host":
      return "/host";
    case "guest":
      return "/guest";
    default:
      return "/";
  }
};

// Helper function to create protected routes
export const createProtectedRoute = (
  element: ReactNode,
  requiredRole?: "admin" | "host" | "guest"
) => {
  return {
    element: <ProtectedRoute requiredRole={requiredRole}>{element}</ProtectedRoute>,
  };
};

// Helper function to create routes configuration
export const createRoutesConfig = (
  basePath: string,
  layoutComponent: ReactNode,
  requiredRole?: "admin" | "host" | "guest"
) => {
  return {
    path: basePath,
    ...createProtectedRoute(layoutComponent, requiredRole),
  };
};
